import { useCallback, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { ResetPasswordConfirmStatus } from "./types/confirmResetPassword";
import styles from "./ConfirmPasswordRecovery.module.less";
import { LoginWrapper } from "../login/LoginWrapper";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PAGE_CHANGE_PASSWORD, PAGE_LOGIN } from "~/constants/page";
import { useConfirmResetPassword } from "./hooks/useConfirmResetPassword";

export const ConfirmPasswordRecovery = () => {
  const navigate = useNavigate();

  const [validationStatus, setValidationStatus] = useState(
    ResetPasswordConfirmStatus.Inprogress,
  );

  const [searchParams] = useSearchParams();
  const queryParamsCode = searchParams.get("code");

  const { messageCode } =
    useConfirmResetPassword(queryParamsCode ?? undefined) ?? {};

  const validationStatusMessageRender = useCallback(() => {
    switch (validationStatus) {
      case ResetPasswordConfirmStatus.Inprogress:
        return (
          <FormattedMessage id="ResetPasswordConfirmModal.Info.inprogressMessage" />
        );

      case ResetPasswordConfirmStatus.OperationSuccess:
      case ResetPasswordConfirmStatus.ResetPasswordRequestTaken:
        return (
          <>
            <FormattedMessage id="ResetPasswordConfirmModal.Info.successMessage" />
            <p className={styles.description}>
              <FormattedMessage id="ResetPasswordConfirmModal.Info.successMessageDescription" />
            </p>
          </>
        );

      case ResetPasswordConfirmStatus.InvalidCode:
        return (
          <>
            <FormattedMessage id="ResetPasswordConfirmModal.Info.invalidTokenMessage" />
            <p className={styles.description}>
              <FormattedMessage id="ResetPasswordConfirmModal.Info.retryResetPassword" />
            </p>
          </>
        );

      case ResetPasswordConfirmStatus.CodeExpired:
        return (
          <>
            <FormattedMessage id="ResetPasswordConfirmModal.Info.expiredTokenMessage" />
            <p className={styles.description}>
              <FormattedMessage id="ResetPasswordConfirmModal.Info.retryResetPassword" />
            </p>
          </>
        );
    }
  }, [validationStatus]);

  useEffect(() => {
    if (messageCode) {
      if (messageCode === ResetPasswordConfirmStatus.UserPasswordExpired) {
        navigate(PAGE_CHANGE_PASSWORD);
      } else {
        setValidationStatus(
          ResetPasswordConfirmStatus[messageCode as ResetPasswordConfirmStatus],
        );
      }
    }
  }, [messageCode, navigate]);

  return (
    <div className={styles.resetPasswordConfirmModal}>
      <LoginWrapper>
        <div className={styles.loginTitle}>
          {validationStatusMessageRender()}
        </div>

        {validationStatus != ResetPasswordConfirmStatus.Inprogress && (
          <p
            onClick={() => navigate(PAGE_LOGIN)}
            className={styles.goToLoginButton}
          >
            <FormattedMessage id="ResetPasswordConfirmModal.Info.goToLoginButton" />
          </p>
        )}
      </LoginWrapper>
    </div>
  );
};
